import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BackHeader, PageTemplate } from '@_widgets/common';
import { InputContainer, SocialMessage } from '@_widgets/user';

import { useLogoutPopup } from '@_features/auth';

import { userApi, userModel } from '@_entities/user';
import { RightChevronIcon } from '@_shared/icons';
import { SkeletonUI } from '@_shared/ui';
import { Typography } from '@_shared/ui/Typography';

import * as S from './EditPage.style';

export function EditPage() {
	const navigate = useNavigate();

	const [user, setUser] = useState<userModel.TUser>();

	const { openLogoutPopup } = useLogoutPopup();

	useEffect(() => {
		userApi.getUser().then(({ data: responseData }) => {
			setUser(responseData);
		});
	}, []);

	return (
		<PageTemplate header={<BackHeader>프로필</BackHeader>} nav={false}>
			{/* Skeleton UI */}
			{user === undefined ? (
				<>
					<S.Form>
						<InputContainer.Container>
							<InputContainer.Label>닉네임</InputContainer.Label>
							<SkeletonUI width="100%" height="48px" borderRadius="8px" />
						</InputContainer.Container>
						<InputContainer.Container>
							<InputContainer.Label>연결된 계정</InputContainer.Label>
							<SkeletonUI width="100%" height="48px" borderRadius="8px" />
						</InputContainer.Container>
					</S.Form>
				</>
			) : (
				<>
					<S.Form>
						<InputContainer.Container>
							<InputContainer.Label>닉네임</InputContainer.Label>
							<S.NicknameChangeButton
								onClick={() => {
									navigate('/user/edit/nickname', {
										state: { nickname: user.nickname },
									});
								}}
							>
								<Typography type="title-small" color="orange-primary">
									변경
								</Typography>
							</S.NicknameChangeButton>
							<InputContainer.Input
								type="text"
								color="font-primary"
								value={user.nickname}
								readOnly
							/>
						</InputContainer.Container>

						<InputContainer.Container>
							<InputContainer.Label>연결된 계정</InputContainer.Label>
							<InputContainer.Input
								type="text"
								color="font-tertiary"
								value={user.email}
								readOnly
							/>
							<InputContainer.Explain>
								<SocialMessage social={user.social} />
							</InputContainer.Explain>
						</InputContainer.Container>
					</S.Form>
				</>
			)}
			<S.Links>
				<S.Link onClick={openLogoutPopup}>
					<Typography type="body-large" color="font-secondary">
						로그아웃
					</Typography>
					<S.LinkIconWrapper>
						<RightChevronIcon />
					</S.LinkIconWrapper>
				</S.Link>

				<S.Link
					onClick={() => {
						navigate('/user/leave');
					}}
				>
					<Typography type="body-large" color="font-secondary">
						회원 탈퇴
					</Typography>
					<S.LinkIconWrapper>
						<RightChevronIcon />
					</S.LinkIconWrapper>
				</S.Link>
			</S.Links>
		</PageTemplate>
	);
}
